import { useNavigate, useParams } from '@tanstack/react-router';
import { StoreCatalogScreen } from '@mrrmlab/feature-lists';

export function StoreCatalogRoute() {
  const { storeId } = useParams({ from: '/einstellungen/geschaefte/$storeId/catalog' });
  const navigate = useNavigate();
  return (
    <StoreCatalogScreen
      storeId={storeId}
      onBack={() => navigate({ to: '/einstellungen/geschaefte' })}
    />
  );
}
